export const getters = {
  getSubscriptionBrandingColor (state) {
    return state?.subscriptionBranding?.color
  },
  hasDataroomStoragePlan (state) {
    return state?.subscription?.dataroomAccessType === 'PLAN'
  },
  hasSubscriptionEnvelopesPacks (state) {
    return state?.subscription?.hasEnvelopesPacks
  },

  /**
   * Logo display logic:
   * If customization is enabled, it returns room's logo or subscription's logo.
   * If no logo is available, it returns null.
   * @returns {string|null} The subscription logo URL or null if not available.
   * */
  getSubscriptionLogo: (state, _getters, rootState) => {
    const currentRoom = rootState?.room?.currentRoom
    const projectLayout = rootState?.global?.projectLayout

    if (projectLayout && currentRoom) {
      const sub = currentRoom.subscription
      const customEnabled = !!sub?.customizationEnabled

      const roomLogo = currentRoom.subscriptionLogo || sub?.logo
      if (customEnabled && roomLogo) return roomLogo
      return null
    }

    return state?.subscriptionBranding?.logo || null
  },
}
